/*
 * ototo-ds-universe.js — which world's rail is showing.
 *
 * Every panel is rendered by the store; this decides which is visible. Panels
 * after the first arrive inside a <template> (kept out of the initial DOM) and
 * are moved into place the first time they are selected — the markup is still
 * the store's, never built here. It never builds markup and never holds a price, so a rail cannot
 * drift out of step with the tile that opened it.
 *
 * Without it the first world shows, every product is a real link and every buy
 * button is a real form post. The page simply stops switching.
 *
 * ⚠️ `hidden` is only a default — the CSS declares
 * [hidden]{display:none !important} against these panels' own attribute.
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-ot-uni]');
  if (!root) return;
  var tabs = [].slice.call(root.querySelectorAll('[data-ot-uni-tab]'));
  var panels = [].slice.call(root.querySelectorAll('[data-ot-uni-panel]'));
  if (!tabs.length) return;

  function hydrate(p) {
    var tpl = p.querySelector('template[data-ot-uni-tpl]');
    if (!tpl) return;
    p.appendChild(tpl.content);
    tpl.remove();
    /* The rail arrows and card galleries bind per element and are idempotent. */
    if (window.__otDsRailsInit) window.__otDsRailsInit();
  }

  function select(id, moveFocus) {
    tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t.getAttribute('data-ot-uni-tab') === id)); });
    panels.forEach(function (p) {
      if (p.getAttribute('data-ot-uni-panel') === id) { hydrate(p); p.removeAttribute('hidden'); }
      else p.setAttribute('hidden', '');
    });
    /* A rail left mid-scroll reopens showing card three. Reset it so every
       world opens on its first product. */
    var rail = root.querySelector('[data-ot-uni-panel="' + id + '"] .ot-rail');
    if (rail) rail.scrollLeft = 0;
    if (moveFocus) {
      var active = tabs.filter(function (t) { return t.getAttribute('data-ot-uni-tab') === id; })[0];
      if (active) active.focus();
    }
  }

  root.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-ot-uni-tab]');
    if (!tab) return;
    select(tab.getAttribute('data-ot-uni-tab'), false);
  });

  /* Hover to switch — the user asked for the rail to change when the pointer is
     over a tile (its name included), no click. Only bind it where a real pointer
     can hover: a touchscreen reports (hover: none), and there the tap handled by
     the click listener above is what switches. Focus is never moved on hover, so
     the page does not jump under a moving pointer. */
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    tabs.forEach(function (t) {
      t.addEventListener('pointerenter', function () {
        select(t.getAttribute('data-ot-uni-tab'), false);
      });
    });
  }

  /* Arrow keys move between tabs — what a tablist is expected to do. */
  root.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-ot-uni-tab]');
    if (!tab) return;
    var i = tabs.indexOf(tab);
    var next = -1;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tabs.length;
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = tabs.length - 1;
    if (next < 0) return;
    e.preventDefault();
    select(tabs[next].getAttribute('data-ot-uni-tab'), true);
  });
})();
